import { AfterViewInit, Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';

import { buildAddressLine1, buildCityStateLine } from 'src/app/core/helper/addresses';

import { MapService } from '../../../core/helper/map.service';
import { Parcel } from '../../../shared/models';
import * as fromApp from '../../../store/index';
import { removeParcel } from '../../../store/parcel/parcel.actions';

@Component({
  selector: 'fc-parcel-info',
  templateUrl: './parcel-info.component.html',
  styleUrls: ['./parcel-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ParcelInfoComponent implements AfterViewInit {
  @ViewChild('dataContainer', { static: false }) dataContainer: ElementRef;
  @Input() parcel: Parcel;
  @Input() readOnly: boolean;

  constructor(readonly store: Store<fromApp.AppState>, private mapService: MapService) {}

  ngAfterViewInit(): void {
    this.dataContainer.nativeElement.innerHTML = this.parcel.svg;
  }
  removeParcel(event: any): void {
    this.store.dispatch(removeParcel({ gid: this.parcel.gid }));
  }

  centerOnParcel() {
    this.mapService.flyToBoundingBox(this.parcel.feature);
  }

  buildAddressLine1(parcel: Parcel): string {
    return buildAddressLine1(parcel.feature.properties);
  }

  buildAddressCityState(parcel: Parcel): string {
    return buildCityStateLine(parcel.feature.properties);
  }

  get approxSize() {
    return this.parcel.getAreaInAcres().toLocaleString('us-EN', { maximumFractionDigits: 2 });
  }
}
